<script>

import ages from '../data/ages.js';
import areas from '../data/areas.js';
import zTable from '../data/z_table.js';


// Constants
const meanHeight = 176;
const deviationHeight = 8;
const minHeight = meanHeight - 3 * deviationHeight;
const maxHeight = meanHeight + 3 * deviationHeight;
const malePopulation = 4663794;


// Calculated values
let percentage ;
let selectedMen;
let selectedAreaName;
let menByAgeandArea;

// Default URL params 
let showResults = false;
let selectedAreaId = 'magyarorszag';
let selectedHeight = 176;
let minAge = 20;
let maxAge = 64;

var queryParams = new URLSearchParams(window.location.search);

if (queryParams.get('show') === 'true') {
  showResults = true;
}

if (queryParams.has('area')) {
  selectedAreaId = queryParams.get('area');
}

if (queryParams.has('minHeight')) {
  selectedHeight = +queryParams.get('minHeight');
}

if (queryParams.has('minAge')) {
  minAge = +queryParams.get('minAge');
}

if (queryParams.has('maxAge')) {
  maxAge = +queryParams.get('maxAge');
}

// Initialize calculation if accessed by url
if (showResults) {
  calculate();
}

function getAgeRate() {

  let sumAges = 0; 
  for (let i = minAge; i <= maxAge; i++) {
    sumAges = sumAges + ages[i];
  }
  return sumAges / malePopulation;
}

// Get standard probability from z table  
function getStandardProbability(zValue) {
  if (zValue >= 0) {
    return +((1 - zTable[+((100 * zValue).toFixed(0))]).toFixed(5));
  } else {
    return +((zTable[+((100 * Math.abs(zValue)).toFixed(0))]).toFixed(5));
  }
}
 
// Calculation
// sets: selectedAreaName, menByAgeandArea, percentage, selectedMen
function calculate() {

  const ageRate = getAgeRate(); 

  const item = areas.find(item => item.id === selectedAreaId);
  const areaMalePopulation = item.male_population;
  selectedAreaName = item.name;

  menByAgeandArea = Math.round(areaMalePopulation * ageRate);

  const zHeight = +(((selectedHeight - meanHeight) / deviationHeight).toFixed(2));
  const heightRate = getStandardProbability(zHeight);
  
  percentage = heightRate * 100;
  
  selectedMen = (menByAgeandArea * heightRate).toFixed(0);
}

function backToSelection() {
  queryParams.set('show', 'false');
  history.pushState(null, null, '?' + queryParams.toString());
  showResults = false;
}

function submitSelection() {

  calculate();

  queryParams.set('show', 'true');
  queryParams.set('minAge', minAge.toString());
  queryParams.set('maxAge', maxAge.toString());
  queryParams.set('area', selectedAreaId.toString());
  queryParams.set('minHeight', selectedHeight.toString());
  history.pushState(null, null, '?' + queryParams.toString());

  showResults = true;
}
  
</script>

  
{#if !showResults}
    
  <h2 class="kozep">Kiválasztás...</h2>

  <div class="box kozep">
    <h3>Életkor</h3>

    <label>
      <p style="padding-top:5px">Minimum:</p>
      <input type=number bind:value={minAge} min=20 max=64>
      <input type=range bind:value={minAge} min=20 max=64>
    </label>
    
    <label>
      <p style="padding-top:5px">Maximum:</p>
      <input type=number bind:value={maxAge} min=20 max=64>
      <input type=range bind:value={maxAge} min=20 max=64>
    </label>

  </div>

  <div class="box kozep">
    <h3>Hely</h3>
    <select bind:value={selectedAreaId}>
      {#each areas as { id, name, region }}
        <option value={id}>
          {#if id !== region}
            &nbsp;&nbsp;&nbsp;
          {/if}
          {name}
        </option>
      {/each}
    </select>
  </div>
  
  <div class="box kozep">
    <h3>Magasság</h3>
    <input type="range" min="{minHeight}" max="{maxHeight}" bind:value={selectedHeight}>
    <p>Minimum elfogadható magasság: {selectedHeight} cm</p>
  </div>

  <div class="kozep">
    <button on:click={submitSelection}>
      Mehet
    </button>
  </div>
  
{:else}
  
  <br>
  <div class="box">
    <p><b>Kiválasztott paraméterek:</b></p>
    <li>Életkor: {minAge} és {maxAge} év között</li>
    <li>Kiválasztott terület: {selectedAreaName}</li>
    <li>Magasság legalább {selectedHeight} cm</li>
  </div>

  <div class="box kozep">
    <h3>Százalék magasság alapján: {percentage}%.</h3>
    <p>A kiválasztott területen és életkorsávban öszesen {menByAgeandArea} férfi van.</p>
    <p>A szűrésed alapján ezekből <b>{selectedMen}</b> db férfi felel meg az elvárásaidnak.</p>
  </div>
    
  <div class="kozep">
    <button on:click={backToSelection}>
      Új szűrés
    </button>
  </div>

{/if}
  

<style>

.kozep {
  text-align: center;
}

div.box {
  border: 1px solid #DDD;
  border-radius: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
  background-color: #f6f6f6;
}

label { 
  display: flex 
}

input, p { 
  margin: 6px 
}

</style>
